var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3C2.89543 3 2 3.89543 2 5V16C2 17.1046 2.89543 18 4 18H11.25V20.25H9C8.58579 20.25 8.25 20.5858 8.25 21C8.25 21.4142 8.58579 21.75 9 21.75H15C15.4142 21.75 15.75 21.4142 15.75 21C15.75 20.5858 15.4142 20.25 15 20.25H12.75V18H20C21.1046 18 22 17.1046 22 16V5C22 3.89543 21.1046 3 20 3H4ZM7.98491 14.2469C7.86327 15.235 7.02097 16 6 16C4.89543 16 4 15.1046 4 14C4 12.8954 4.89543 12 6 12C6.65324 12 7.23333 12.3132 7.59832 12.7976L11.5151 11.7531C11.6367 10.765 12.479 10 13.5 10C13.6772 10 13.8491 10.0231 14.0127 10.0663L16.2874 7.0335C16.105 6.73188 16 6.3782 16 6C16 4.89543 16.8954 4 18 4C19.1046 4 20 4.89543 20 6C20 7.10457 19.1046 8 18 8C17.8228 8 17.6509 7.97694 17.4873 7.93366L15.2126 10.9665C15.395 11.2681 15.5 11.6218 15.5 12C15.5 13.1046 14.6046 14 13.5 14C12.8468 14 12.2667 13.6868 11.9017 13.2024L7.98491 14.2469Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.eea1baaa2e4cd7606f166ea7869e57e0.svg";
export { ForwardRef as ReactComponent };